import React, { useState, useRef, useEffect } from "react";
import "./modal.scss";
import "react-multi-date-picker/styles/layouts/prime.css";
// import { connection } from "utils/apiConnection.ts";
// import useInput from "hooks/use-input";
import Select, { StylesConfig } from "react-select";
import toast from "react-hot-toast";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { RiAddCircleLine } from "react-icons/ri";
import { FaCheckCircle } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdFileDownloadDone } from "react-icons/md";
import useAxios from "../../../services/useAxios";
import { Col, Row } from "react-bootstrap";
import { NumericFormat, PatternFormat } from "react-number-format";
import { useImmer } from "use-immer";
import { AddIcon, TrashIcon } from "../../kits/Icons/Icons.tsx";
import MapIR from "../../address/MapIR.jsx";

export default function AddSupplier({ setUpdater, updater, setIsLoading }) {
  // نقشه
  const [address, setAddress] = useState();
  // const auth = useContext(AuthenticationContext);
  const [Nextstep, setNextstep] = useState(true);
  const [location, setLocation] = useState({
    lngLat: { lng: "", lat: "" }
  });
  // نقشه
  // شیفت کاری
  const [selectedShiftDays, setSelectedShiftDays] = useState([
    { id: "0", day: "شنبه", checked: false },
    { id: "1", day: "یک شنبه", checked: false },
    { id: "2", day: "دوشنبه", checked: false },
    { id: "3", day: "سه شنبه", checked: false },
    { id: "4", day: "چهارشنبه", checked: false },
    { id: "5", day: "پنج شنبه", checked: false },
    { id: "6", day: "جمعه", checked: false }
  ]);

  const [shiftTime, setShiftTime] = useState({
    start_hour: "",
    start_min: "",
    finish_hour: "",
    finish_min: ""
  });
  const [shiftTimeList, setShiftTimeList] = useState([]);

  // useEffect(() => {
  //   shiftTimeList.sort(function(a, b) {
  //     return a.time1 - b.time1;
  //   });
  // }, [shiftTimeList]);
  // شیفت کاری
  const [filterCat, setFilterCat] = useState();
  const [allProductTags, setAllProductTags] = useState([
    { value: "55", label: "jj" }
  ]);
  const [cartType, setCartType] = useState([
    { value: " 0", label: "نقدی" },
    { value: "1", label: "اعتباری" }
  ]);
  const pattern = /^09\d{9}$/;
  const tellPattern = /^0\d{10}$/;
  const patternNumbercart = /^\d{16}$/;
  const patternNumberAcount = /^\d{13}$/;
  const patternSheba = /^\d{24}$/;
  const [infoBank, setInfoBank] = useState({
    numberCart: "",
    nameBank: "",
    cartType: "",
    Shebanumber: "",
    accountNumber: ""
  });
  const bankJSON = JSON.stringify(infoBank);
  const [infoBankValid, setInfoBankValid] = useImmer({
    numberCart: true,
    nameBank: true,
    Shebanumber: true
  });

  const InfoBankValidation = () => {
    let cardNumber = infoBank.numberCart
      .replaceAll("-", "")
      .replaceAll(/\s/g, "");
    let sheba = infoBank.Shebanumber.replaceAll("IR", "").replaceAll(/\s/g, "");

    const validation = [
      patternNumbercart.test(cardNumber),
      infoBank.nameBank != "",
      patternSheba.test(sheba)
    ];

    setInfoBankValid(draft => {
      draft.numberCart = validation[0];
      draft.nameBank = validation[1];
      draft.Shebanumber = validation[2];
    });

    return validation[0] && validation[1] && validation[2];
  };
  const [listInfoBank, setListInfoBank] = useState([]);
  const inputElement = useRef();
  const [allUsers, setAllUsers] = useState([]);
  const [allLeader, setAllLeader] = useState([]);
  const [valueDateFinish, setValueDateFinish] = useState("");
  const [update, setUpdate] = useState(false);
  const [otherInfo, setOtherInfo] = useState({
    title: "",
    token: "",
    main_admin_uid: "",
    user_mobile: "",
    fullname: "",
    cover_file_id: [],
    path: [],
    main_cat: "-1",
    line_ids: [],
    description: "",
    tell1: "",
    startTime: "",
    start_hour: "",
    start_min: "",
    finish_hour: "",
    finish_min: "",
    endTime: "",
    tell2: "",
    email: "",
    site: "",
    instagram: "",
    mobile: "",
    address: "",
    min_order_amount: "",
    businessLiecenseFileId: [],
    lat: "",
    lang: ""
  });
  // console.log("otherInfoAdd", otherInfo);
  const [displaycats, setcats] = useState([]);

  const [disabledBtn, setDisabledBtn] = useState(false);
  const [valid, setValid] = useState({
    tell1: true,
    tell2: true,
    mobile: true,
    user_mobile: true
  });

  const validate = () => {
    const validation = [
      pattern.test(otherInfo.mobile) && otherInfo.mobile != "",
      // tellPattern.test(otherInfo.tell1) && otherInfo.tell1 != "",
      true,
      true,
      // otherInfo.tell2 == ""
      //   ? true
      //   : tellPattern.test(otherInfo.tell2) && otherInfo.tell2 != "",
      otherInfo.main_admin_uid.value != "-1"
        ? true
        : pattern.test(otherInfo.user_mobile) && otherInfo.user_mobile != ""
    ];

    setValid({
      ...valid,
      mobile: validation[0],
      tell1: validation[1],
      tell2: validation[2],
      user_mobile: validation[4]
    });

    return validation[0] && validation[1] && validation[2] && validation[3];
  };

  const { updateSupplier, execute: addSupplierApi } = useAxios(
    "superadminapi/add_supplier"
  );
  const { loadingSupplierData, execute: getAddSupplierDataApi } = useAxios(
    "superadminapi/get_add_suppliers_data"
  );
  const {
    loadingEditSupplierData,
    execute: getAddEditSupplierDataApi
  } = useAxios("superadminapi/get_add_edit_product_data");

  async function postHandler() {
    setIsLoading(true);
    if (otherInfo.title == "") {
      toast.error("نام    را وارد نمایید");
      return null;
    }
    if (otherInfo.main_cat === "-1") {
      toast.error("دسته بندی    را وارد نمایید");
      return null;
    }
    if (otherInfo.main_admin_uid.length == 0) {
      toast.error("کاربر را وارد نمایید");
      return null;
    }
    if (otherInfo.main_admin_uid.value == "-1" && otherInfo.user_mobile == "") {
      toast.error("موبایل کاربر را وارد کنید");
      return null;
    }

    if (otherInfo.logo_file_id === undefined) otherInfo.logo_file_id = "";
    setDisabledBtn(true);
    let days = selectedShiftDays.filter(v => v.checked == true);
    let times = {};
    for (let i = 0; i < days.length; i++) {
      times[days[i].id] = shiftTimeList;
    }
    console.log("shuft", times);
    let result = await addSupplierApi({
      bank_info: JSON.stringify(listInfoBank),
      token: otherInfo.token,
      user_mobile: otherInfo.user_mobile,
      fullname: otherInfo.fullname,
      cover_file_id: otherInfo.logo_file_id,
      logo_file_id: otherInfo.cover_file_id,
      main_cat: otherInfo.main_cat,
      description: otherInfo.description,
      tell1: otherInfo.tell1,
      tell2: otherInfo.tell2,
      email: otherInfo.email,
      mobile: otherInfo.mobile,
      title: otherInfo.title,
      address: otherInfo.address,
      // startTime: valueDateStart.valueOf(),
      // endTime: valueDateFinish.valueOf(),
      // start_hour: otherInfo.start_hour,
      // start_min: otherInfo.start_min,
      // finish_hour: otherInfo.finish_hour,
      // finish_min: otherInfo.finish_min,
      min_order_amount: otherInfo.min_order_amount,
      main_admin_uid: otherInfo.main_admin_uid.value,
      line_ids: otherInfo.line_ids.map(value => value.value).join(","),
      site: otherInfo.site,
      instagram: otherInfo.instagram,
      supplierSheet: JSON.stringify(times)
    });

    setcats([]);
    if (result.status == 1) {
      toast.success("کسب و کار با موفقیت اضافه شد");
      setUpdater(!updater);
      setIsLoading(false);
      setOtherInfo({
        token: "",
        title: "",
        main_admin_uid: [],
        user_mobile: "",
        fullname: "",
        cover_file_id: [],
        logo_file_id: [],
        main_cat: "-1",
        line_ids: [],
        description: "",
        tell1: "",
        tell2: "",
        email: "",
        mobile: "",
        address: "",
        min_order_amount: ""
      });
      setDisabledBtn(false);
      inputElement.current.click();
    } else {
      toast.error("     خطا در اضافه کردن کسب و کار!");
      setDisabledBtn(false);
    }
  }

  const changeHandleraTags = option => {
    setOtherInfo(prev => {
      let temp = { ...prev };
      temp.line_ids = option;
      return { ...temp };
    });
  };

  function handleChange(event) {
    setOtherInfo({
      ...otherInfo,
      [event.target.name]: removeCommas(event.target.value)
    });
  }

  const changeHandler = (names, value) => {
    if (names == "start") {
      // setOtherInfo(prev => {
      setShiftTime(prev => {
        return {
          ...prev,
          start_hour: value.split(":")[0],
          start_min: value.split(":")[1]
        };
      });
    } else if (names == "finish") {
      setShiftTime(prev => {
        return {
          ...prev,
          finish_hour: value.split(":")[0],
          finish_min: value.split(":")[1]
        };
      });
    }
  };
  const RemoveInfoBank = index => {
    let newArray = listInfoBank.filter((value, index2, array) => {
      if (index == index2) {
        return false;
      } else {
        return true;
      }
    });
    setListInfoBank(newArray);
  };

  function inputChangeHandler(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }

  const changeHandlerImg = e => {
    setOtherInfo({ ...otherInfo, [e.target.name]: e.target.files[0] });
  };

  const inputRef = useRef();

  useEffect(() => {
    async function loadPage() {
      // let result = await connection("superadminapi/get_add_suppliers_data", {});
      let result = await getAddSupplierDataApi();

      let allProductTags = [];
      let allUsers = [];

      for (let index = 0; index < result.lines.length; index++) {
        let newObject = {};
        newObject.value = result.lines[index].id;
        newObject.label = result.lines[index].title;
        newObject.main_cat = result.lines[index].main_cat;
        newObject.parent_line_id = result.lines[index].parent_line_id;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
      for (let index = 0; index < result.user_for_admin.length; index++) {
        let newObject = {};
        newObject.value = result.user_for_admin[index].id;
        newObject.label = result.user_for_admin[index].fullname;
        allUsers.push(newObject);
      }
      setAllUsers(allUsers);
      // ----------------
      let data = await getAddEditSupplierDataApi();
      //     connection(
      //   "superadminapi/get_add_edit_product_data",
      //   {}
      // );
      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject = data.cats[index];

        allLeader.push(newObject);
      }
      setAllLeader(allLeader);
    }
    loadPage();
  }, []);

  const translateUserToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.fullname = arrayValue[index].label;
        obj.id = arrayValue[index].value;
        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].fullname;
        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  // list of brands
  const [user, setuser] = useState([]);
  useEffect(() => {
    getAddSupplierDataApi().then(data => {
      setuser(prev => {
        return [
          { fullname: "ثبت کاربر جدید", id: "-1" },
          ...data.user_for_admin
        ];
      });
    });
    // connection("superadminapi/get_add_suppliers_data").then((data) => {
    //   setuser((prev) => {
    //     return [
    //       { fullname: "ثبت کاربر جدید", id: "-1" },
    //       ...data.user_for_admin,
    //     ];
    //   });
    // });
  }, [update]);
  const userOptions = translateUserToReactSelect(user, false);
  const [displayStatusUser, setDisplayStatusUser] = useState("d-none");

  function inputChangeHandlerDaste(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
    setFilterCat(event.target.value);
  }

  const test = allProductTags.filter(
    item => item.parent_line_id == 0
    // {
    //   if (item.main_cat == filterCat && item.parent_line_id == 0) {
    //     return item;
    //   }
    // }
  );

  // const setAddModalErrorMsg = () => {
  // check the ref exists (it should always exist, it's declared in the JSX below), and call a regular javascript scrollTo function on it

  // }

  return (
    <>
      <div
        class="modal fade add-campain"
        id={`exampleModalAdd`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
        style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
      >
        <div className="modal-dialog modal-fullscreen p-4">
          <div className="modal-content overflow-hidden h-auto">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اضافه کردن کسب و کار
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="shop-setting d-flex justify-content-center">
                <form className="w-100 d-flex flex-column align-items-center">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-title"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        نام فروشگاه
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-title"
                          name="title"
                          className="form-control"
                          value={otherInfo.title}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-2">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-leastOrders"
                        className="form-label col-12 col-sm-3"
                      >
                        حداقل سفارش
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          placeholder="مبلغ به تومان"
                          id="shop-leastOrders"
                          name="min_order_amount"
                          className="form-control"
                          value={addCommas(otherInfo.min_order_amount)}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* کاربر */}
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="user"
                        className="form-label col-12 col-sm-3"
                      >
                        کاربر
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          className=" filterSelect "
                          id="user"
                          // isMulti={true}
                          options={userOptions}
                          value={otherInfo.main_admin_uid}
                          onChange={e => {
                            setOtherInfo(prev => {
                              return { ...prev, main_admin_uid: e };
                            });

                            if (e.value == "-1") {
                              setDisplayStatusUser("d-block");
                            } else {
                              setDisplayStatusUser("d-none");
                            }
                          }}
                        />
                      </div>
                    </div>
                    {/* ایجاد کاربر جدید */}
                    <div
                      className={`d-flex ${displayStatusUser} rounded`}
                      style={{ border: "1px dashed lightgray" }}
                    >
                      <div className="w-50 p-1">
                        <label>نام کاربر:</label>
                        <input
                          className="form-control"
                          type="text"
                          name="fullname"
                          value={otherInfo.fullname}
                          onChange={inputChangeHandler}
                        ></input>
                      </div>
                      <div className="w-50 p-1">
                        <label>موبایل کاربر</label>
                        <NumericFormat
                          displayType="input"
                          id="shop-tell1"
                          allowLeadingZeros
                          className="form-control"
                          name="user_mobile"
                          value={otherInfo.user_mobile}
                          onChange={inputChangeHandler}
                        />
                        {!valid.user_mobile && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-main_admin_uid"
                        className="form-label col-12 col-sm-3"
                      >
                        لاین
                      </label>
                      <div className="col-12 col-sm-9">
                        <Select
                          id="tags"
                          className=" filterSelect "
                          options={test}
                          placeholder="لطفا لاین را انتخاب کنید"
                          // {
                          //   test.length > 0 ? (
                          //     <div> لطفا لاین را انتخاب کنید</div>
                          //   ) : (
                          //     <div> دسته بندی را انتخاب کنید</div>
                          //   )
                          // }
                          value={otherInfo.line_ids}
                          onChange={changeHandleraTags}
                          // options={tagsOptions}
                          isMulti={true}
                          style={{ background: "#ddd" }}
                          // value={defaultTags}
                        />
                      </div>
                    </div>
                    {/* <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        ساعت کار فروشگاه
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-startTime"
                            name="startTime"
                            className="form-control"
                            value={`${otherInfo.start_hour}:${otherInfo.start_min}`}
                            onChange={e => {
                              changeHandler("start", e.target.value);
                            }}
                          />
                        </div>
                        <label
                          className="form-label  text-center"
                          style={{ margin: "auto" }}
                        >
                          الی
                        </label>
                        <div className="col-12">
                          <input
                            style={{ background: "#ddd" }}
                            type="time"
                            id="shop-endTime"
                            name="endTime"
                            className="form-control"
                            value={`${otherInfo.finish_hour}:${otherInfo.finish_min}`}
                            onChange={e => {
                              changeHandler("finish", e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        آپلود جواز کسب و کار
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <input
                            className="form-control"
                            type="file"
                            style={{ background: "#ddd" }}
                            onChange={e => {
                              setOtherInfo(prev => {
                                return {
                                  ...prev,
                                  businessLiecenseFileId: e.target.files[0]
                                };
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        نقشه
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          <div className="pd-x-4 my-2">
                            <MapIR
                              // location={location}
                              height={138}
                              setAddress={setAddress}
                              setLocation={setLocation}
                              setNextstep={setNextstep}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-address"
                        className="form-label col-12 col-sm-3"
                      >
                        آدرس
                      </label>
                      <div className="col-12 col-sm-9">
                        <textarea
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-address"
                          name="address"
                          className="form-control"
                          value={otherInfo.address}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-start mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        شیفت های کاری
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-12">
                          {/* شیفت کاری */}
                          <div className="accordion " id="shiftWork">
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed title-h4-m shadow-none "
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseOne"
                                  aria-expanded={false}
                                  aria-controls="collapseOne"
                                  style={{
                                    height: "40px",
                                    color: "#111827",
                                    backgroundColor: "#ddd"
                                  }}
                                >
                                  تعیین روزهای کاری
                                </button>
                              </h2>
                              <div
                                id="collapseOne"
                                className="accordion-collapse collapse "
                                data-bs-parent="#shiftWork"
                              >
                                <div className="accordion-body">
                                  {selectedShiftDays.map((value, index) => {
                                    return (
                                      <div className="form-check mr-b-8">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={value.id}
                                          value={value.checked}
                                          onChange={() => {
                                            setSelectedShiftDays(
                                              selectedShiftDays.map((v, i) => {
                                                if (i == index) {
                                                  return {
                                                    ...v,
                                                    checked: !value.checked
                                                  };
                                                }
                                                return v;
                                              })
                                            );
                                            console.log(
                                              "days:",
                                              selectedShiftDays
                                            );
                                          }}
                                        />
                                        <label
                                          className="form-check-label mr-r-12 txt-t2-m"
                                          htmlFor={value.id}
                                        >
                                          {value.day}
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* شیفت کاری */}
                          {/* اضافه کردن شیفت کاری */}
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-start mb-3">
                      <label
                        className=" col-12 col-sm-3 "
                        style={{ margin: "auto" }}
                      >
                        ساعت شیفت کاری
                      </label>
                      <div className="col-12 col-sm-9 row align-items-baseline justify-content-between p-0 m-0">
                        <div className="col-6">
                          <div className="accordion " id="shiftTime"></div>
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button collapsed title-h5-m shadow-none px-2 rounded"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#shiftTimeWork"
                                aria-expanded={false}
                                aria-controls="shiftTimeWork"
                                style={{
                                  height: "40px",
                                  color: "#111827",
                                  backgroundColor: "#ddd"
                                }}
                              >
                                اضافه کردن شیفت کاری
                              </button>
                            </h2>
                            <div
                              id="shiftTimeWork"
                              className="accordion-collapse collapse "
                              data-bs-parent="#shiftTime"
                            >
                              <div className="accordion-body">
                                <h6 className="txt-t3-m">انتخاب ساعت</h6>
                                <div className="d-flex">
                                  <div className="w-50 mx-1">
                                    <h6
                                      className="text-center mb-1"
                                      style={{ fontSize: 11 }}
                                    >
                                      از ساعت
                                    </h6>
                                    <input
                                      // name="startTime"
                                      value={`${shiftTime.start_hour}:${shiftTime.start_min}`}
                                      onChange={e => {
                                        changeHandler("start", e.target.value);
                                      }}
                                      type="time"
                                      className="form-control px-1"
                                      style={{ width: "110px" }}
                                    />
                                  </div>
                                  <div className="w-50 mx-1">
                                    <h6
                                      className="text-center mb-1"
                                      style={{ fontSize: 11 }}
                                    >
                                      تا ساعت
                                    </h6>
                                    <input
                                      value={`${shiftTime.finish_hour}:${shiftTime.finish_min}`}
                                      onChange={e => {
                                        changeHandler("finish", e.target.value);
                                      }}
                                      type="time"
                                      style={{ width: "110px" }}
                                      className="form-control px-1"
                                    />
                                  </div>
                                </div>

                                <div className="text-end mt-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success"
                                    onClick={() => {
                                      if (
                                        shiftTime.start_hour != "" &&
                                        shiftTime.finish_hour != ""
                                      ) {
                                        shiftTimeList.push(shiftTime);
                                        console.log(
                                          "shift time list",
                                          shiftTimeList
                                        );
                                        setShiftTime({
                                          start_hour: "",
                                          start_min: "",
                                          finish_hour: "",
                                          finish_min: ""
                                        });
                                      }
                                    }}
                                  >
                                    افزودن
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          {shiftTimeList?.map((value, index) => {
                            return (
                              <div
                                className="d-flex justify-content-between"
                                style={{
                                  padding: 6,
                                  borderBottom:
                                    index != shiftTimeList.length - 1 &&
                                    "1px solid #111827"
                                }}
                              >
                                <div style={{ fontSize: 12 }}>
                                  <span>ساعت </span>
                                  <span>{`${value.start_min} : ${value.start_hour}`}</span>
                                  <span> تا </span>
                                  <span>{`${value.finish_min} : ${value.finish_hour}`}</span>
                                  <h6 style={{ fontSize: 10 }}>
                                    شیفت
                                    {index == 0
                                      ? " اول"
                                      : index == 1
                                      ? " دوم"
                                      : index == 2
                                      ? " سوم"
                                      : index == 3
                                      ? " چهارم"
                                      : index == 4
                                      ? " پنجم"
                                      : index == 5
                                      ? " ششم"
                                      : index == 6
                                      ? " هفتم"
                                      : index == 7
                                      ? " هشتم"
                                      : index == 8
                                      ? " نهم"
                                      : " دهم"}
                                  </h6>
                                </div>
                                <div
                                  onClick={() => {
                                    setShiftTimeList(
                                      shiftTimeList.filter(v => v != value)
                                    );

                                    console.log("shift", shiftTimeList);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <TrashIcon />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    {/* اضافه کردن شیفت کاری */}
                  </div>
                </form>
                <form className="w-100 d-flex flex-column align-items-center form2">
                  <div className="w-100">
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        دسته بندی
                      </label>
                      <div className="col-12 col-sm-9">
                        <select
                          name="main_cat"
                          class="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          style={{
                            background: "#ddd",
                            direction: "rtl",
                            padding: "9px"
                          }}
                          value={otherInfo.main_cat}
                          onChange={inputChangeHandlerDaste}
                        >
                          <option selected hidden value="-1" disabled>
                            انتخاب کنید
                          </option>
                          {allLeader?.map((value, index) => (
                            <option key={index} value={index}>
                              {value}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-description"
                        className="form-label col-12 col-sm-3"
                      >
                        توضیحات
                      </label>
                      <div className="col-12 col-sm-9">
                        <textarea
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-description"
                          name="description"
                          className="form-control"
                          value={otherInfo.description}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-cover_file_id"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        لوگو
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="cover_file_id"
                          className="form-control"
                          type="file"
                          id="shop-cover_file_id"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-logo_file_id"
                        className="form-label col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        کاور
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          onChange={changeHandlerImg}
                          style={{ background: "#ddd" }}
                          ref={inputRef}
                          name="logo_file_id"
                          className="form-control"
                          type="file"
                          id="shop-logo_file_id"
                          accept="image/*"
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell1"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-tell1"
                          allowLeadingZeros
                          name="tell1"
                          className="form-control"
                          value={otherInfo.tell1}
                          onChange={inputChangeHandler}
                        />
                        {!valid.tell1 && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-tell2"
                        className="form-label col-12 col-sm-3"
                      >
                        تلفن 2
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-tell2"
                          allowLeadingZeros
                          name="tell2"
                          className="form-control"
                          value={otherInfo.tell2}
                          onChange={inputChangeHandler}
                        />
                        {!valid.tell2 && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-mobile"
                        className="form-label col-12 col-sm-3"
                      >
                        موبایل
                      </label>
                      <div className="col-12 col-sm-9">
                        <NumericFormat
                          displayType="input"
                          decimalScale={3}
                          allowLeadingZeros
                          style={{ background: "#ddd", direction: "rtl" }}
                          id="shop-mobile"
                          name="mobile"
                          className="form-control"
                          value={otherInfo.mobile}
                          onChange={inputChangeHandler}
                        />

                        {!valid.mobile && (
                          <p className="validate-text">
                            شماره وارد شده صحیح نیست.
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="row align-items-baseline mb-3">
                      <label
                        style={{ margin: "auto" }}
                        htmlFor="shop-email"
                        className="form-label col-12 col-sm-3"
                      >
                        ایمیل
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-email"
                          name="email"
                          className="form-control"
                          value={otherInfo.email}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-site"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        وبسایت
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-site"
                          name="site"
                          className="form-control"
                          value={otherInfo.site}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                    <div className="row align-items-baseline mb-3">
                      <label
                        htmlFor="shop-instagram"
                        className=" col-12 col-sm-3"
                        style={{ margin: "auto" }}
                      >
                        اینستاگرام
                      </label>
                      <div className="col-12 col-sm-9">
                        <input
                          style={{ background: "#ddd" }}
                          type="text"
                          id="shop-instagram"
                          name="instagram"
                          className="form-control"
                          value={otherInfo.instagram}
                          onChange={inputChangeHandler}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                style={{
                  background: "#668cd9",
                  width: "200px",
                  height: "50px",
                  color: "white",
                  padding: "7px",
                  textAlign: "center",
                  borderRadius: "7px 7px 0px 0px",
                  fontSize: "18px",
                  fontWeight: "bold"
                }}
              >
                اطلاعات بانکی
              </div>
              <div
                style={{
                  backgroundColor: "#668cd9",
                  width: "100%",
                  height: "100%",
                  color: "white",
                  borderRadius: "7px 0px 7px 7px"
                }}
              >
                {/*<div className="row p-3">*/}
                <Row className="d-flex flex-column justify-content-center">
                  <Col xs={10} md={7} className="mx-auto mt-4">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="nameBank"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      نام بانک{" "}
                    </Col>

                    <Col>
                      <input
                        style={{ background: "#ddd" }}
                        type="text"
                        id="nameBank"
                        name="nameBank"
                        className="form-control"
                        value={infoBank.nameBank}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            nameBank: e.target.value
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            infoBankValid.nameBank == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا نام بانک را وارد کنید.
                      </p>
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="nameBank"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره حساب{" "}
                    </Col>

                    <Col>
                      <NumericFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        id="accountNumber"
                        name="accountNumber"
                        className="form-control"
                        value={infoBank.accountNumber}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            accountNumber: e.target.value
                          });
                        }}
                      />
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="shomare"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره کارت{" "}
                    </Col>

                    <Col>
                      <PatternFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        format="#### - #### - #### - ####"
                        id="numberCart"
                        name="numberCart"
                        className="form-control"
                        value={infoBank.numberCart}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            numberCart: e.target.value
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            infoBankValid.numberCart == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا شماره کارت را به درستی وارد کنید.
                      </p>
                    </Col>
                  </Col>

                  <Col xs={10} md={7} className="mx-auto">
                    <Col
                      className="d-flex mb-1"
                      htmlFor="shomare"
                      style={{
                        whiteSpace: "nowrap"
                      }}
                    >
                      شماره شبا{" "}
                    </Col>

                    <Col>
                      <PatternFormat
                        dir="ltr"
                        displayType="input"
                        style={{ background: "#ddd" }}
                        id="Shebanumber"
                        name="Shebanumber"
                        placeholder="IR"
                        format="IR ###### ###### ###### ######"
                        className="form-control"
                        value={infoBank.Shebanumber}
                        onChange={e => {
                          setInfoBank({
                            ...infoBank,
                            Shebanumber: e.target.value
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            infoBankValid.Shebanumber == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا شماره شبا را به درستی وارد کنید.
                      </p>
                    </Col>
                  </Col>

                  <Col
                    className="mx-auto mb-2"
                    style={{
                      width: "90px",
                      backgroundColor: "#eb4b97",
                      borderRadius: "17px",
                      padding: "5px 11px",
                      textAlign: "center",
                      cursor: "pointer",
                      color: "white",
                      fontSize: "17px"
                    }}
                    onClick={() => {
                      if (InfoBankValidation()) {
                        setInfoBank({
                          numberCart: "",
                          nameBank: "",
                          cartType: "",
                          Shebanumber: "",
                          accountNumber: ""
                        });
                        // console.log("infobank:,", infoBank);
                        // console.log("Listinfobank:,", listInfoBank);
                        setListInfoBank(prev => {
                          let temp = [...prev];
                          //temp.push(infoBank);
                          return [...temp, { ...infoBank, checked: true }];
                        });
                      }
                    }}
                  >
                    <div className="justify-content-between">
                      <span style={{ marginLeft: "7px" }}>
                        <MdFileDownloadDone></MdFileDownloadDone>
                      </span>
                      <span>ثبت</span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div
              class="tab-pane fade show active"
              id="v-pills-home"
              role="tabpanel"
              aria-labelledby="v-pills-home-tab"
              style={{ margin: "12px" }}
            >
              {listInfoBank.length > 0
                ? listInfoBank.map((value, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex flex-row px-3 my-3 mx-12 text-center text-md-start"
                        style={{
                          border: "2px solid #A7A9D6",
                          borderRadius: "10px"
                          // width: "48%",
                        }}
                      >
                        <div
                          className="form-check form-switch"
                          style={{ paddingTop: "13px" }}
                        >
                          <input
                            className="form-check-input"
                            name="checked"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            onChange={event => {
                              event.persist();
                              setListInfoBank(prev => {
                                let temp = [...prev];
                                temp[index].checked = event.target.checked;
                                // console.log("after", temp);
                                return temp;
                              });
                            }}
                            checked={listInfoBank[index].checked}
                          />
                        </div>

                        <div className="d-flex flex-column justify-content-around w-100">
                          <div className="d-flex flex-column justify-content-between flex-wrap ">
                            <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                              <div>
                                <div className="d-xl-flex-row justify-content-between">
                                  <div>شماره کارت : {value.numberCart}</div>
                                  <div>نام بانک : {value.nameBank}</div>
                                </div>
                                <div>
                                  شماره حساب:{" "}
                                  {value.accountNumber
                                    ? value.accountNumber
                                    : ""}
                                </div>

                                <div>شماره شبا: {value.Shebanumber}</div>
                              </div>
                              <div className="d-flex ">
                                <div>
                                  <h4 data-tip="حذف ">
                                    <RiDeleteBin5Line
                                      className="tlg1"
                                      onClick={() => RemoveInfoBank(index)}
                                    />
                                  </h4>
                                  <ReactTooltip />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : ""}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={inputElement}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  // validate()
                  if (validate()) {
                    postHandler(otherInfo);
                  }
                }}
                disabled={disabledBtn}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
